import React, {useEffect} from "react"
import { Outlet } from "react-router-dom"
import { Spin, Layout, theme } from "antd"

import ContactUs from "@components/ContactUs"
import ReleaseAlert from "@components/ReleaseAlert"
import PlatformFooter from "@components/PlatformFooter"
import useProjectsStore from "@stores/investor/useProjectsStore"
import { useAppContext } from "@components/AppContext"
import useDocumentsStore from "@stores/investor/useDocumentsStore"
import useInvestmentsStore from "@stores/investor/useInvestmentsStore"
import useTransactionsStore from "@stores/investor/useTransactionsStore"
import { W1, W5, WIDTH_MAX, isMobile } from "@components/constants"

import Header from "./Header"
import SecondFactorAlert from "./SecondFactorAlert"
import InvalidSourcesAlert from "./InvalidSourcesAlert"
import ImpersonatedAccountAlert from "./ImpersonatedAccountAlert"

import "./InvestorLayout.css"


const InvestorLayout = () => {
  const { token } = theme.useToken()
  const { colorBgLayout, colorBgContainer } = token

  const { request } = useAppContext()

  const projectsStore = useProjectsStore(request)
  const documentsStore = useDocumentsStore(request, false)
  const investmentsStore = useInvestmentsStore(request)
  const transactionsStore = useTransactionsStore(request)

  const { investments } = investmentsStore
  const { transactions } = transactionsStore
  const { projects, getProject } = projectsStore

  const context = {
    ...projectsStore,
    ...documentsStore,
    ...investmentsStore,
    ...transactionsStore,
  }

  useEffect(() => {
    document
      .querySelector('meta[name="viewport"]')
      .setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1")
  }, [])

  const layoutStyle = {
    minHeight: 100,
    marginBottom: isMobile ? W5 * 3 : 0,
    backgroundColor: colorBgContainer
  }

  const headerStyle = {
    top: 0,
    zIndex: 1,
    padding: 0,
    position: "sticky",
    borderBottom: "1px solid rgba(0,0,0,0.1)",
    backgroundColor: colorBgLayout,
  }

  const contentLayoutStyle = {
    width: "100%",
    margin: "0 auto",
    padding: isMobile ? 0 : `${W1}px ${W1}px`,
    maxWidth: WIDTH_MAX,
  }

  if (!isMobile) {
    contentLayoutStyle.minHeight = "60vh"
  }

  const isReady =
    !!projects &&
    !!investments &&
    !!transactions

  return (
    <Spin spinning={!isReady}>
      <Layout style={layoutStyle}>
        {
          isReady && (
            <>
              <div className="header-alerts">
                <ReleaseAlert />
                <ImpersonatedAccountAlert />
                <SecondFactorAlert />
                <InvalidSourcesAlert
                  getProject={getProject}
                  investments={investments}
                />
              </div>

              <Layout.Header style={headerStyle}>
                <Header />
              </Layout.Header>

              <Layout.Content style={contentLayoutStyle}>
                <Outlet context={context}/>
              </Layout.Content>

              <ContactUs />

              <PlatformFooter />
            </>
          )
        }
      </Layout>
    </Spin>
  )
}

export default InvestorLayout
